<template>
  <common-wrap :preview-data="previewData">
    <div class="info-container">
      暂不支持.{{
        previewData.fileType
      }}类型文件在线预览，请点击下载按钮下载后查看
    </div>
  </common-wrap>
</template>

<script>
import commonWrap from "@/components/commonWrap";
import common from "@/mixins/common";

export default {
  name: "notSupport",
  mixins: [common],
  components: {
    commonWrap,
  },
};
</script>

<style lang="scss" scoped>
.info-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #ffffff;
}
</style>
